<div class="legend-list-container">
    <div class="title-container">
        <div class="title">Legend List</div>
        <button mat-raised-button color="primary" (click)="addAll()" matTooltip="Add all legends to the sequence"
            [disabled]="!(icRoundService.isInLastRound$ | async) ||isAddAllDisabled() || !(parseExperiment() | statusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : experiment : 'IsAnyStatus')">Add
            all</button>
    </div>
    <div class="table-container">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>

            <!-- LegendId Column -->
            <ng-container matColumnDef="legendDataId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky>LegendId</th>
                <td mat-cell *matCellDef="let element">{{ element.legendId }}</td>
            </ng-container>

            <!-- LegendName Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky>LegendName</th>
                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
            </ng-container>

            <!-- Add To Sequence Column -->
            <ng-container matColumnDef="addToSequence">
                <th mat-header-cell *matHeaderCellDef sticky>Add To Sequence</th>
                <td mat-cell *matCellDef="let element">
                    <button mat-mini-fab color="primary" (click)="addToSequence(element)"
                        matTooltip="Add legend to sequence"
                        [disabled]="!(icRoundService.isInLastRound$ | async) || isDisabled() || !(parseExperiment() | statusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : experiment : 'IsAnyStatus')"><mat-icon>add</mat-icon></button>
                </td>
            </ng-container>

            <!-- N Column -->
            <ng-container matColumnDef="n">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky>N</th>
                <td mat-cell *matCellDef="let element">{{ getTimesAdded(element) }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>
<div class="sequence-container">
    <div class="title-container">
        <button mat-raised-button color="warn" (click)="removeAll()" matTooltip="Remove all the sequence"
            [disabled]="!(icRoundService.isInLastRound$ | async) || this.sequenceDataSource.data.length == 0 || !(parseExperiment() | statusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : experiment : 'IsAnyStatus')">Remove
            all the sequence</button>
        <button color="primary" (click)="loadPreviousSequence()"
            *ngIf="(icRoundService.isInLastRound$ | async) && (icRoundService.currentRound$ | async) != 1 && (parseExperiment() | statusIs : ['Created'])"
            mat-raised-button>Load the previous sequence</button>
        <div class="title">Legend Ids list in sequence order</div>
        <button mat-raised-button color="primary" matTooltip="Save sequence order"
            [disabled]="!(icRoundService.isInLastRound$ | async) || isSetReadyDisabled() || !(parseExperiment() | statusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : experiment : 'IsAnyStatus')"
            (click)="saveSequence()">Save sequence order</button>
        <button mat-raised-button color="primary" matTooltip="Set experiment Ready"
            [disabled]="!(icRoundService.isInLastRound$ | async) || isSetReadyDisabled() || !(parseExperiment() | statusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : experiment : 'IsAnyStatus')"
            (click)="setReady()">Set it as Ready</button>
    </div>
    <div class="table-container">
        <table mat-table [dataSource]="sequenceDataSource" class="mat-elevation-z8" matSort cdkDropList
            (cdkDropListDropped)="drop($event)">

            <!-- Sequence Order Column -->
            <ng-container matColumnDef="sequenceOrder">
                <th mat-header-cell *matHeaderCellDef sticky>Sequence Order</th>
                <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                </td>
            </ng-container>

            <!-- LegendId Column -->
            <ng-container matColumnDef="legendDataId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky>LegendId</th>
                <td mat-cell *matCellDef="let element">{{ getLegendId(element.legendDataId) }}</td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky>Name</th>
                <td mat-cell *matCellDef="let element">{{ getLegendName(element.legendDataId) }}</td>
            </ng-container>

            <!-- Incubation Column -->
            <ng-container matColumnDef="incubationS">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky>Incubation</th>
                <td mat-cell *matCellDef="let element">
                    <input matInput type="number" [(ngModel)]="element.incubationS" min="1"
                        [disabled]="!(icRoundService.isInLastRound$ | async) ||isDisabled() || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : experiment : 'IsAnyStatus')"
                        [matTooltip]="(element.incubationS > 0 && element.incubationS < 10) ? 'Incubation must be 0 or greater than 9 seconds' : ''"
                        [class.error-input]="element.incubationS > 0 && element.incubationS < 10" />
                </td>
            </ng-container>

            <!-- Delay Column -->
            <ng-container matColumnDef="delayS">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky>Delay</th>
                <td mat-cell *matCellDef="let element">
                    <input matInput type="number" [(ngModel)]="element.delayS" min="1"
                        [disabled]="!(icRoundService.isInLastRound$ | async) || isDisabled() || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : experiment : 'IsAnyStatus')" />
                </td>
            </ng-container>

            <!-- Number Of Images Set Column -->
            <ng-container matColumnDef="numberOfImageSets">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky>Number Of Images Set</th>
                <td mat-cell *matCellDef="let element">
                    <input matInput type="number" [(ngModel)]="element.numberOfImageSets" min="1"
                        [disabled]="!(icRoundService.isInLastRound$ | async) || isDisabled() || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : experiment : 'IsAnyStatus')" />
                </td>
            </ng-container>

            <!-- Order Column -->
            <ng-container matColumnDef="order">
                <th mat-header-cell *matHeaderCellDef sticky>Order</th>
                <td mat-cell *matCellDef="let element; let i = index">
                    <button mat-icon-button (click)="moveUp(i)"
                        [disabled]="!(icRoundService.isInLastRound$ | async) || i === 0 || !(parseExperiment() | statusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : experiment : 'IsAnyStatus')"
                        color="primary">
                        <mat-icon>arrow_upward</mat-icon>
                    </button>
                    <button mat-icon-button (click)="moveDown(i)"
                        [disabled]="!(icRoundService.isInLastRound$ | async) || i === sequenceDataSource.data.length - 1 || !(parseExperiment() | statusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : experiment : 'IsAnyStatus')"
                        color="primary">
                        <mat-icon>arrow_downward</mat-icon>
                    </button>
                    <button mat-icon-button (click)="removeRow(i)" color="warn"
                        [disabled]="!(icRoundService.isInLastRound$ | async) || isDisabled() || !(parseExperiment() | statusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : experiment : 'IsAnyStatus')">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="sequenceDisplayedColumns; sticky:true"></tr>
            <tr mat-row *matRowDef="let row; columns: sequenceDisplayedColumns;" cdkDrag
                [cdkDragDisabled]="!(parseExperiment() | statusIs : ['Created']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : experiment : 'IsAnyStatus')">
            </tr>
        </table>
    </div>
</div>